<template>
	<div class="multi-select-toolbar" @click.stop>
		<div class="toolbar-shell">
			<div class="toolbar-status">
				<span class="status-label">已选</span>
				<span class="selection-badge">{{ selectedCount }}</span>
				<span v-if="selectedCount >= maxSelection" class="max-limit-tip">上限</span>
			</div>
			<div class="toolbar-actions">
				<button type="button" class="toolbar-action" :disabled="selectedCount < 2" @click.stop="$emit('merge-forward')">
					<span class="action-icon">
						<i class="el-icon-document-copy"></i>
					</span>
					<span class="action-label">合并转发</span>
				</button>
				<button type="button" class="toolbar-action primary" :disabled="selectedCount === 0" @click.stop="$emit('batch-forward')">
					<span class="action-icon">
						<i class="el-icon-s-promotion"></i>
					</span>
					<span class="action-label">逐条转发</span>
				</button>
				<button type="button" class="toolbar-action danger" :disabled="selectedCount === 0" @click.stop="$emit('batch-delete')">
					<span class="action-icon">
						<i class="el-icon-delete"></i>
					</span>
					<span class="action-label">删除</span>
				</button>
			</div>
			<button type="button" class="cancel-btn" title="退出多选" @click.stop="$emit('cancel')">
				<i class="el-icon-close"></i>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "selectionToolbar",
	props: {
		selectedCount: {
			type: Number,
			default: 0
		},
		maxSelection: {
			type: Number,
			default: 20
		}
	}
}
</script>

<style scoped lang="scss">
.multi-select-toolbar {
	display: flex;
	flex-direction: column;
	flex-shrink: 0;
	min-height: 96px;
	height: 96px;
	padding: 6px 12px 10px;
	background: transparent;

	.toolbar-shell {
		display: grid;
		grid-template-columns: auto minmax(0, 1fr) auto;
		align-items: center;
		gap: 12px;
		flex: 1;
		min-height: 0;
		height: 100%;
		padding: 0 12px;
		border-radius: 6px;
		border: 1px solid var(--im-surface-panel-border);
		background: var(--im-chat-bg);
		box-shadow: none;
	}

	.toolbar-status {
		display: flex;
		align-items: center;
		gap: 8px;
		min-width: 72px;
		flex-shrink: 0;

		.status-label {
			font-size: 12px;
			font-weight: 500;
			color: var(--im-text-color-light);
			white-space: nowrap;
		}
	}

	.selection-badge {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 28px;
		height: 28px;
		padding: 0 8px;
		border-radius: 4px;
		background: rgba(var(--im-primary-rgb), 0.1);
		color: var(--im-color-primary);
		font-size: 13px;
		font-weight: 700;
	}

	.max-limit-tip {
		display: inline-flex;
		align-items: center;
		height: 20px;
		padding: 0 7px;
		border-radius: 4px;
		background: rgba(var(--im-warning-rgb), 0.14);
		color: var(--im-color-warning);
		font-size: 11px;
		line-height: 1;
		white-space: nowrap;
		font-weight: 600;
	}

	.toolbar-actions {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 18px;
		min-width: 0;
		overflow-x: auto;
		padding: 0 2px;
	}

	.toolbar-action {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 8px;
		min-width: 76px;
		padding: 0;
		border: 0;
		background: transparent;
		color: var(--im-text-color);
		cursor: pointer;
		transition: opacity 0.2s ease;

		.action-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 42px;
			height: 42px;
			border-radius: 6px;
			border: 1px solid var(--im-control-border);
			background: var(--im-control-soft-bg);
			transition: border-color 0.2s ease, background-color 0.2s ease, color 0.2s ease;
		}

		i {
			font-size: 17px;
		}

		.action-label {
			font-size: 12px;
			font-weight: 500;
			line-height: 1.2;
			white-space: nowrap;
		}

		&:hover:not(:disabled) {
			.action-icon {
				border-color: rgba(var(--im-primary-rgb), 0.16);
				background: rgba(var(--im-primary-rgb), 0.08);
			}
		}

		&:disabled {
			cursor: not-allowed;
			opacity: 0.42;
		}

		&.primary {
			color: var(--im-color-primary);

			.action-icon {
				background: rgba(var(--im-primary-rgb), 0.1);
				color: var(--im-color-primary);
			}
		}

		&:not(.danger):not(.primary) {
			.action-icon {
				color: var(--im-text-color);
			}
		}

		&.danger {
			color: var(--im-color-danger);

			.action-icon {
				background: rgba(var(--im-danger-rgb), 0.1);
				color: var(--im-color-danger);
			}
		}
	}

	.cancel-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		flex-shrink: 0;
		border: 0;
		border-radius: 6px;
		background: transparent;
		color: var(--im-text-color-light);
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			background: rgba(var(--im-primary-rgb), 0.08);
			color: var(--im-text-color);
		}
	}
}

@media (max-width: 900px) {
	.multi-select-toolbar {
		padding-left: 10px;
		padding-right: 10px;

		.toolbar-shell {
			padding: 0 12px;
		}

		.toolbar-actions {
			gap: 12px;
		}
	}
}

@media (max-width: 640px) {
	.multi-select-toolbar {
		height: 90px;
		min-height: 90px;
		padding: 4px 8px 10px;

		.toolbar-shell {
			grid-template-columns: 1fr auto;
			grid-template-areas:
				"status close"
				"actions actions";
			gap: 8px;
			padding: 8px 10px 10px;
			align-items: start;
		}

		.toolbar-status {
			grid-area: status;
			min-width: 0;
		}

		.toolbar-actions {
			grid-area: actions;
			justify-content: space-between;
			gap: 10px;
			overflow: visible;
		}

		.cancel-btn {
			grid-area: close;
			width: 32px;
			height: 32px;
			border-radius: 6px;
			justify-self: end;
		}

		.toolbar-action {
			min-width: 0;
			flex: 1;
			gap: 6px;

			.action-icon {
				width: 38px;
				height: 38px;
			}

			.action-label {
				font-size: 11px;
			}
		}

		.selection-badge {
			min-width: 24px;
			height: 24px;
			font-size: 12px;
		}
	}
}
</style>
